export const HEATMAP_WEEKDAY_LABELS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const HEATMAP_HOUR_LABELS = [
  '12:00am',
  '2:00am',
  '4:00am',
  '6:00am',
  '8:00am',
  '10:00am',
  '12:00pm',
  '2:00pm',
  '4:00pm',
  '6:00pm',
  '8:00pm',
  '10:00pm',
];

export const HEATMAP_COLORS = [
  '#e0e592',
  '#aed396',
  '#a9d194',
  '#a0ce93',
  '#99cd94',
  '#8cc894',
  '#5eb391',
  '#5db492',
  '#5cb391',
  '#5aad8c',
  '#3984a3',
];

export const REDDIT_USER_BASE_URL = 'https://www.reddit.com/user/';
